import React from 'react';
import { categories } from '../../data/products';

export default function CategoryStrip() {
  return (
    <div className="max-w-[1400px] mx-auto px-4 lg:px-6 mt-10">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-display text-[28px]">Shop by Category</h2>
        <a href="#shop" className="text-sm font-semibold text-indigo-600 hover:underline">View All →</a>
      </div>
      <div className="flex gap-4 overflow-x-auto no-scrollbar pb-2">
        {categories.map((cat, idx) => (
          <a key={idx} className="group min-w-[110px] text-center" href="#">
            <div className="w-[110px] h-[110px] rounded-[24px] overflow-hidden bg-slate-100">
              <img src={cat.img} className="w-full h-full object-cover group-hover:scale-110 transition" alt={cat.name} />
            </div>
            <p className="mt-2 text-[13px] font-semibold">{cat.name}</p>
          </a>
        ))}
      </div>
    </div>
  );
}